export default __webpack_public_path__ + "static/media/6.b7ab2b02.jpg";